import { render, staticRenderFns } from "./AgeForm.vue?vue&type=template&id=7f92927e"
import script from "./AgeForm.vue?vue&type=script&lang=js"
export * from "./AgeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports